import { Duration, proto3, Timestamp } from '@bufbuild/protobuf';
import { createMsgWithdrawDelegatorReward, generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { fromDuration, toTimestamp } from 'cosmjs-types/helpers';
import { MsgFulfillOrder as MsgFulfillOrderProto } from '../proto/tx_pb';
import { MsgFulfillOrder } from '../ts-client/tx';

const CREATE_MSG_FULFILL_ORDER_TYPES = ({
  MsgValue: [
    { name: 'fulfiller_address', type: 'string' },
    { name: 'order_id', type: 'string' },
    { name: 'expected_fee', type: 'string' },
  ],
});

export const createTxMsgFulfillOrder = (context: TxContext, params: MsgFulfillOrder): TxPayload => {
  const typedData = createEIP712MsgFulfillOrder(context, params);
  const cosmosMsg = createCosmosMsgFulfillOrder(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgFulfillOrder = (context: TxContext, params: MsgFulfillOrder): EIP712TypedData => {
  const types = generateTypes(CREATE_MSG_FULFILL_ORDER_TYPES);
  const message = createMsgFulfillOrder(params);
  return { types, message };
};

const createCosmosMsgFulfillOrder = (context: TxContext, params: MsgFulfillOrder): any => {
  const message = new MsgFulfillOrderProto({
    orderId: params.orderId,
    expectedFee: params.expectedFee,
    fulfillerAddress: params.fulfillerAddress,
  });
  return { message, path: MsgFulfillOrderProto.typeName };
};

function createMsgFulfillOrder(params: MsgFulfillOrder): object {
  return {
    type: 'eibc/MsgFulfillOrder',
    value: {
      fulfiller_address: params.fulfillerAddress,
      order_id: params.orderId,
      expected_fee: params.expectedFee,
    },
  };
}

